import {
  PTM_APPLICATION_TYPES,
  isDeniedPtmApplication,
  pickLatestApplicationForType,
} from "../../../../utils/prospect/ptmApplicationStatus"
import { REQUIREMENT } from "./constants/levels"
import { STATUS } from "./constants/statuses"

/**
 * pgmProgressStatus reports a denied Member application as Open (the person may
 * apply again), so the denial only shows up in the Member applications list.
 * Returns the latest Member application when it was denied and the Apply card is
 * still Open; null otherwise. Behind `applications-membership` like the other
 * Member-application surfaces: with the flag off the card keeps the legacy form.
 */
export const resolveEnrollmentDenial = ({
  requirement,
  memberApplications,
  applicationsMembershipEnabled,
}) => {
  if (applicationsMembershipEnabled !== true) return null
  if (requirement?.key !== REQUIREMENT.ENROLLMENT) return null
  if (requirement.status !== STATUS.OPEN) return null

  const latest = pickLatestApplicationForType(
    memberApplications,
    PTM_APPLICATION_TYPES.MEMBER,
  )
  return isDeniedPtmApplication(latest?.status) ? latest : null
}
